<template>
    <div class="fullHeight">
        <MypageSideMenu :memberDropClose="false"/>
        <Card
            :page_title="page_title"
            iconclass="icon-icon-reserve mypage-title-icon"
            >
            <div class="col-sm-12">
                <p class="text-left">領収書に印字する宛名を入力してください。</p>
                <div class="form-group row">
                    <label class="col-sm-1 col-form-label">宛名</label>
                    <div class="col-sm-7">
                        <input
                            id="receipt_addressee"
                            type="text"
                            class="col form-control friend-line"
                            v-model="receiptAddressee"
                            maxlength="50"
                        />
                    </div>
                    <div class="col-sm-3">
                        <div class="row justify-content-center">
                            <button
                                type="button"
                                class="submit_style bluebackbutton"
                                v-on:click="submit"
                            >
                            発行
                            </button>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center mb-3 mypagebackcontent">
                    <button
                        class="mypagebackbutton"
                        @click="BackResultList">
                    一覧へ戻る</button>
                </div>
            </div>
            <ErrorDialog
                v-show="showErrorDialog"
                v-bind:errorWording="errorWording"
                v-on:closeErrorDialog="OnCloseErrorDialog"
            ></ErrorDialog>
        </Card>
        <MypageMenuFooter/>
    </div>
</template>

<script>
import MypageSideMenu from "./MypageSideMenu";
import validater from "../../lib/validater";
import Card from '../components/Card';
import ErrorDialog from '../components/ErrorDialog';
import { GET_RECEIPT_ADDRESSEE } from '../../constants/receipts';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        validater,
        ErrorDialog,
        Card
    },
    data () {
        return {
            page_title: '宛名入力',
            settleNo: 1,
            memberNo: '',
            receiptAddressee: '',
            submit_disabled: true,
            showErrorDialog: false,
            errorWording: ''
        };
    },
    created () {
        this.Initialize();
    },

    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async Initialize () {
            this.memberNo = this.$store.state.auth.loginMember.member_no;
            if (sessionStorage.getItem('MyPage.settleNo')) {
                this.settleNo = sessionStorage.getItem('MyPage.settleNo');
            } else {
                this.settleNo = '0';
            }
            if (sessionStorage.getItem('MyPage.addressee')) {
                this.receiptAddressee = sessionStorage.getItem('MyPage.addressee');
            } else {
                this.getReceiptsAddressee();
            }
            // console.log(this.$store.state.auth);
        },
        /** ----------------------------------------------
         * 領収書の宛名取得
         * ---------------------------------------------- */
        getReceiptsAddressee: async function () {
            this.$store.commit("loading/setIsLoading", true);
            this.$apollo.query({
                query: GET_RECEIPT_ADDRESSEE,
                fetchPolicy: 'no-cache',
                variables: {
                    settle_no: this.settleNo
                }
            }).then(res => {
                this.receiptAddressee = res.data.GetReceiptAddressee.ReceiptAddressee.member_name;
                this.$store.commit("loading/setIsLoading", false);
            }).catch(error => {
                this.errorWording = '領収書の宛名取得に失敗しました。';
                this.showErrorDialog = true;
                this.$store.commit("loading/setIsLoading", false);
            })
        },
        /** ----------------------------------------------
         * 携帯番号変更ボタン押下時処理
         * ---------------------------------------------- */
        submit: async function (event) {
            sessionStorage.setItem('MyPage.addressee', this.receiptAddressee);
            this.$router.push({ path: '/Receipt' });

        },
        /** ----------------------------------------------
         * エラーダイアログ閉じる
         * ---------------------------------------------- */
        OnCloseErrorDialog: function () {
            this.showErrorDialog = false;
        },
        /** ----------------------------------------------
         * 実績一覧へ戻る
         * ---------------------------------------------- */
        BackResultList: function (){
            this.$router.push({ path: '/mypage-result-list' });
        }

    }
}

</script>

<style scoped>
.submit_style {
    width: 120px;
}
.mypagebackbutton {
    width: 250px;
}
.friend-line {
    margin-bottom: 20px;
}
.mypagebackcontent {
    margin-left: -15px;
    margin-right: -15px;
}
@media screen and (max-width: 575px) {
  .submit_style {
    width: 50%;
}
  .mypagebackbutton {
    width: 50%;
  }
}
</style>
